import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IPostDocumento } from 'src/app/interfaces/documento';
import { DocumentoService } from 'src/app/services/documento/documento.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.scss']
})
export class DocumentosComponent implements OnInit {
  subscriptions$ = new Subscription();
  documento: IPostDocumento[];

  constructor(
    private documentoService: DocumentoService,
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {}

  ngOnInit(): void {
    this.getDocumentos();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe(); // Cleanup subscription
  }

  getDocumentos() {
    this.subscriptions$.add(
      this.documentoService.postDocumento().subscribe({
        next: (response) => {
          this.documento = response.data;
        }
      })
    )
  }

  getSafeUrl(contentType: string, base64Content: string) {
    return this.sanitizer.bypassSecurityTrustUrl(`data:${contentType};base64,${base64Content}`);
  }
}